export const apiPaths = {
  accounts: {
    subaccounts: ({ accountId }: { accountId: string }) => `accounts/${accountId}/subaccounts`,
    profile: 'accounts/profile',
    permissions: 'accounts/profile/permissions',
  },
  users: {
    accessProfile: ({ id }: { id: number }) => `User/${id}/accessProfile`,
  },
  alarmSubscription: {
    alarmSubscriptions: 'alarmSubscription',
    account: 'alarmSubscription/account',
    site: ({ siteId }: { siteId: number | string }) => `alarmSubscription/site/${siteId}`,
  },
  chambers: {
    newSpills: 'chambers/newSpills',
    newSpillsReport: 'chambers/newSpills/report',
    newSpillsScheduleReport: 'chambers/newSpills/report/schedule',
    history: ({ siteId }: { siteId: number | string }) => `chambers/${siteId}/history`,
    pauseAlarm: ({ siteId }: { siteId: number | string }) => `chambers/${siteId}/alarms/pause`,
    unpauseAlarm: ({ siteId }: { siteId: number | string }) => `chambers/${siteId}/alarms/unpause`,
    pauseAlarmBulk: `chambers/alarms/pause`,
    unpauseAlarmBulk: `chambers/alarms/unpause`,
    //
    trendGraph: ({ siteId }: { siteId: number | string }) => `chambers/${siteId}/trend`,
    photos: ({ siteId }: { siteId: number | string }) => `chambers/${siteId}/photos`,
    install: ({ siteId }: { siteId: number | string }) => `chambers/${siteId}/install`,
    //
    siteAlarmConditions: ({ siteId }: { siteId: number | string }) => `chambers/${siteId}/alarm/options`,
  },
  notes: {
    notes: 'notes',
  },
  featureFlags: {
    features: `features/account`,
  },
};
